import React, { useEffect, useState } from "react";
import CommonToast from '../../../Common_Components/CommonToast'
import { useWorkspace } from '../../../../contexts/WorkspaceContext';
import { useNavigate } from "react-router-dom";
import { Box, Button, Dialog, DialogActions, DialogTitle, IconButton, Modal, Tab, Tabs, Typography } from "@mui/material";
import { button_bg_color_for_New_Project, hoveredSettings_Nav_bg_dm, selecetedSettings_Nav_bg_dm, settingsModal_bg_color_dm, uploadFiles_button_default_bg_color, uploadFiles_button_hovered_bg_color } from "../../../../constants/colors";
import CloseIcon from '@mui/icons-material/Close';
import { containsMediaFile } from "../../../../contexts/WorkspaceUtils";
import ImageRatio from "../ImageSettings/ImageRatio";
import ImageModel from "../ImageSettings/ImageModel";
import ImageFormat from "../ImageSettings/ImageFormat";
import FormatAndLayout from "./FormatAndLayout";
import Design from "./Design";
import TextContent from "./TextContent";
import ImageContect from "./ImageContect";

const PPTSettings = () => {

     const { setTemplateId,
         showPptSettings, 
         setShowPptSettings,
         setCurrentThread,
         currentThread,
         setSending,
         setWaitThread,
         setThreadFiles,
         setHistoryFiles,
         selectedOneClickButtonFromWebtrackNotificationMsg,
         setSelectedOneClickButtonFromWebtrackNotificationMsg,
         notificationTextFromWebTracking,
         setNotificationTextFromWebTracking,
         clearThread,
         setThreadId,
         setIswebTrackClicked,
         sendMessage,
         setCurrentWebsiteLinkedId,
         stopMessageIdRef, setVisibleStopGenerationButton,
         userMediaSettings,
         } = useWorkspace();
      const [showModal, setShowModal] = useState(false);
      const [selectedTheme, setSelectedTheme] = useState("theme2");
      const theme = localStorage.getItem('theme');
      const [pptSettingsSaved,setPptSettingsSaved] = useState(false);
      const [activeTab, setActiveTab] = useState('textContent');
      const token = localStorage.getItem('token');
      const navigate = useNavigate();

  const handleSubmit = async (input) => {
    setIswebTrackClicked(false);
    // trackSearchInteraction(input);
    setCurrentWebsiteLinkedId(null);
    clearThread();
    setThreadFiles([]);
    setHistoryFiles([]);
    localStorage.removeItem("current_thread_id");
    localStorage.removeItem("current_history_id");
    // const newThreadId = await createThreadId();
    // setThreadId(newThreadId);
    setVisibleStopGenerationButton(true)
    setSending(true);
    setWaitThread(true);
    if (input?.trim()) {
      const latestEntry = { sender: "user", content: input };
      // setCurrentThread((prevThread) => {
      //   const updatedThread = prevThread[prevThread.length - 1]?.sender === "user"
      //     ? prevThread.slice(0, -1) // Remove the last entry if it's from the user
      //     : prevThread;
      //   return [...updatedThread, latestEntry];
      // })
      if(currentThread[currentThread.length - 1]?.sender !== "user"){
        setCurrentThread((prevThread) => [...prevThread, latestEntry]);
      }
      
      const entryResponse = await sendMessage(latestEntry).catch(console.error);
      // if(findUrl(entryResponse.content)){
      //   setHasLink(true)
      //   await extractLinks(entryResponse.content)
      //   }
      if (entryResponse) {
        const url = findUrl(entryResponse.content);
        if (url && url.includes("dailylimitexceeded")) {
          const fileFormat = getFileFormat(url);
          const responseMessage = {
            content: `Hi there,\n\nIt looks like you’ve reached your daily limit for generating `+ fileFormat +` files...`,
            sender: 'modalX',
          };
          setCurrentThread((prevThread) => [...prevThread, responseMessage]);
        }else if(stopMessageIdRef.current.includes(entryResponse.unique_id)){
          setCurrentThread((prevThread)=>[...prevThread ])
          setVisibleStopGenerationButton(false);
        }
         else {
          // setCurrentThread((prevThread) => [...prevThread, entryResponse]);
          if(containsMediaFile(entryResponse.content)){
            setCurrentThread((prevThread) => [...prevThread, entryResponse]);
          }else{
            setCurrentThread((prevThread) => [...prevThread, entryResponse]);
            setVisibleStopGenerationButton(false);
          }
        }
        setSending(false);
      } else {
        setCurrentThread((prevThread) => [...prevThread, { content: "Unable to process your query!..", sender: 'modalX' }]);
        setSending(false);
        setVisibleStopGenerationButton(false);
      }
    }
  
    setWaitThread(false);
  };

   const findUrl = (msg) => {
    const urlRegex = /(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt))/g;
    const match = urlRegex.exec(msg);
    return match ? match[1] : null;
  };

  const getFileFormat = (url) => {
    // Extract the file extension from the URL
    const parts = url.split('.');
    if (parts.length > 1) {
      return parts[parts.length - 1]; // Return the last part as the file format
    } else {
      return ''; // Return empty string if no file extension found
    }
  };

const handleCloseToast = () => {
    setPptSettingsSaved(false);
  };

   const handleSave = () => {
    console.log('Settings saved');
    setPptSettingsSaved(true);
    setShowPptSettings(false);
  };

    const handleClose = () => {
    setShowModal(false);
    setShowPptSettings(false);
  };

    const handleCloseGenerate = () => {
    setShowModal(false);
    setShowPptSettings(false);
    setSelectedOneClickButtonFromWebtrackNotificationMsg('');
    setNotificationTextFromWebTracking('');
  }

const removeUrlsAndBrackets = (msg) => {
    return msg.replace(/\[.*?\]\((?:https?:\/\/[^\s\)\]]+|Link)\)/g, '');
  };

    const handleSaveAndGenerate = () => {
    setIswebTrackClicked(false);
    setCurrentWebsiteLinkedId(null);
    navigate("/workspace");
    setPptSettingsSaved(true);
    setShowPptSettings(false);
    handleSubmit(removeUrlsAndBrackets(notificationTextFromWebTracking));
    setSelectedOneClickButtonFromWebtrackNotificationMsg('');
    setNotificationTextFromWebTracking('');
  }

    const renderContent = () => {
      switch (activeTab) {
        case 'textContent':
          return <TextContent />;
        case 'imageContent':
          return <ImageContect />;
        case 'formatAndLayout':
          return <FormatAndLayout />;
        default:
          return <TextContent />;
      }
    };


  return (
    <>
        <CommonToast 
        open={pptSettingsSaved}
        onClose={handleCloseToast}
        content="Presentation settings saved"
        bgColor="#282D51"
        fontColor="#fff"
        fontSize="14px"
        fontWeight="500"
        autoHideDuration={3000}
        iconType = 'success'
      />
       <Modal
            open={showPptSettings}
            onClose={handleClose}
            aria-labelledby="image-settings-title"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
             
            }}
          >
         <Box
        sx={{
          width: '900px',
          height: '636px',
          backgroundColor: 'background.paper',
          boxShadow: 24,
          // p: 4,
          display: 'flex',
          flexDirection: 'column',
          bgcolor: theme === 'dark' ? settingsModal_bg_color_dm : '',
          borderRadius:'8px',
          
        }}
      >
        <Typography
          id="image-settings-title"
          variant="h6"
          component="h2"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            // mb: 2,
            borderBottom: `1px solid ${theme === 'dark' ? '#535774' : ''}`,
            padding:'20px',
            fontFamily: 'Inter, sans-serif',
          }}
          style={{fontSize:'20px',fontWeight:'600',color:theme === 'dark'?'#FFFFFF':''}}
        >
          Presentation Settings
          <IconButton
            aria-label="close"
            onClick={selectedOneClickButtonFromWebtrackNotificationMsg === ''?handleClose:handleCloseGenerate}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Typography>
        <Box sx={{ display: 'flex', flexGrow: 1 }}>
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={activeTab}
            onChange={(event, newValue) => setActiveTab(newValue)}
            sx={{
              borderRight: 1,
              borderColor: theme === 'dark' ? '#535774' : '',
              minWidth: '150px',
              display: 'flex',
              flexDirection: 'column',
              width:'223px',
              paddingTop:"20px"
            }}
            TabIndicatorProps={{
              style: {
                display: 'none', // Hide the default indicator (blue underline)
              },
            }}
          >
             <Tab
              label="Text Content"
              value="textContent"
              sx={{
                backgroundColor: activeTab === 'textContent' ? selecetedSettings_Nav_bg_dm : 'transparent', // Grey background for selected tab
                '&:hover': {
                  backgroundColor: theme === 'dark' ? hoveredSettings_Nav_bg_dm : '', // Light grey on hover
                },
                color: theme === 'dark' ? 'white' : 'black',
                textTransform: 'none',
                fontSize: '14px',
                margin:'0 20px 4px 20px',
                borderRadius:'8px'
              }}
              style={{color:'#FFFF'}}
            />
              <Tab
              label="Image Content"
              value="imageContent"
              sx={{
                backgroundColor: activeTab === 'design' ? selecetedSettings_Nav_bg_dm : 'transparent', // Grey background for selected tab
                '&:hover': {
                  backgroundColor: theme === 'dark' ? hoveredSettings_Nav_bg_dm : '', // Light grey on hover
                },
                color: theme === 'dark' ? 'white' : 'black',
                textTransform: 'none',
                fontSize: '14px',
                margin:'0 20px 4px 20px',
                borderRadius:'8px'
              }}
              style={{color:'#FFFF'}}
            />
            <Tab
              label="Format And Layout"
              value="formatAndLayout"
              sx={{
                backgroundColor: activeTab === 'formatAndLayout' ? selecetedSettings_Nav_bg_dm : 'transparent', // Grey background for selected tab
                '&:hover': {
                  backgroundColor: theme === 'dark' ? hoveredSettings_Nav_bg_dm : '', // Light grey on hover
                },
                color: theme === 'dark' ? 'white' : 'black',
                textTransform: 'none',
                fontSize: '14px',
                margin:'0 20px 4px 20px',
                borderRadius:'8px'
              }}
              style={{color:'#FFFF'}}
            />
          </Tabs>
          <Box
            sx={{
              flexGrow: 1,
              pl: 3,
              overflowY: 'auto',
              maxHeight: '430px',
              width:'457px',
              paddingTop:"20px"
            }}
          >
            {renderContent()}
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            // mt: 2,
            p: 2,
            borderTop: `1px solid ${theme === 'dark' ? '#444' : '#ccc'}`, // Border top added
          }}
        >
          <Button
            onClick={selectedOneClickButtonFromWebtrackNotificationMsg === ''?handleClose:handleCloseGenerate}
            sx={{
              mr: 1,
              backgroundColor: theme === 'dark' ? uploadFiles_button_default_bg_color : '',
              '&:hover': {
                backgroundColor: uploadFiles_button_hovered_bg_color,
              },
              color: '#17182C',
              fontSize: '16px',
              fontWeight: '600',
              textTransform: 'none',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            Close
          </Button>
          <Button
            variant="contained"
            onClick={selectedOneClickButtonFromWebtrackNotificationMsg === ''?handleSave:handleSaveAndGenerate}
            sx={{
              backgroundColor: theme === 'dark' ? button_bg_color_for_New_Project : '',
              '&:hover': {
                backgroundColor: '#FFD9AA',
              },
              color: '#17182C',
              fontSize: '16px',
              fontWeight: '600',
              textTransform: 'none',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            {selectedOneClickButtonFromWebtrackNotificationMsg === ''?'Save':'Save and generate image'}
          </Button>
        </Box>
      </Box>
          </Modal>
    </>
  )
}

export default PPTSettings